import { RecordDataSource } from "../../../records/grids";
import { escapeAngularExpressionValueGetter } from "../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";

export const vsObjectName = "slotcheckEmailTemplate";
export const vsGridSettingsSymbol = Symbol(vsObjectName);

slotcheckEmailTemplateObjectConfig.$inject = [
  RecordGridViewServiceProviderName,
];
export function slotcheckEmailTemplateObjectConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureGrid(recordGridViewServiceProvider);
}

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      columnDefinitionService: ColumnDefinitionService
    ) => {
      return {
        columns: [
          columnDefinitionService.getNumberColDef({
            field: "Id",
            header: "Id",
            hide: true,
          }),

          columnDefinitionService.getStringColDef({
            field: "Name",
          }),
          columnDefinitionService.getStringColDef({
            field: "MailSubject",
            header: "Subject",
            valueGetter: escapeAngularExpressionValueGetter,
          }),
          columnDefinitionService.getStringColDef({
            field: "MailBody",
            header: "Body",
            valueGetter: escapeAngularExpressionValueGetter,
          }),
        ],
        defaultSort: "Name",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/process/template"
        ),
        gridSettings: gridSettingsService.getGridSettings(vsGridSettingsSymbol),
        nameSingular: "Template",
      };
    },
  ]);
}
